export default {
  name: 'insight',
  productInfo: 'productInfo',
  productInfoInterval: 'productInfoInterval',
  productSnapshot: 'productSnapshot',
  productGrowth: 'productGrowth',
  productTop: 'productTop'
};
